import EmploymentPortals from '../EmploymentPortals.vue'
import EmploymentPortalsView from '../Views/EmploymentPortalsView.vue'

const EmploymentPortalsRoute = {
    path: '/employment-portals',
    meta: {
        name: {
            en: 'Employment Portals',
            es: 'Portales de Empleo'
        }
    },
    component: EmploymentPortals,
    children: [
        {
            path: '',
            component: EmploymentPortalsView,
            name: 'EmploymentPortals',
        }
    ]
}

export default EmploymentPortalsRoute
